import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';
import { RecentActivityRowType } from '@/types/dashboardTypes';

export const getRecentActivityApi = (): Promise<ApiResponseType<{ results: RecentActivityRowType[] }>> => {
  return authApiService.GET('/dashboard/recent-activity/');
};
